import { render, staticRenderFns } from "./ProductRowFive.vue?vue&type=template&id=f63f017c&scoped=true&"
import script from "./ProductRowFive.vue?vue&type=script&lang=js&"
export * from "./ProductRowFive.vue?vue&type=script&lang=js&"
import style0 from "./ProductRowFive.vue?vue&type=style&index=0&id=f63f017c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63f017c",
  null
  
)

export default component.exports